import { Typography } from "@mui/material"
import React from "react"
export const PanelSettings = (): JSX.Element => {
    return (
        <Typography variant="h5" color="secondary.main">
            Configurações
        </Typography>
    )
}